"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultMaintenance = void 0;
const defaultCircuitBreakerMaintenance_1 = require("./defaultCircuitBreakerMaintenance");
const defaultCacheMaintenance_1 = require("./defaultCacheMaintenance");
/**
 * Maintenance for resilience proxies.
 */
class DefaultMaintenance {
    /**
     * Initializes a new instance of the @see Maintenance class.
     * @param proxies Proxies to use for maintenance.
     * @param cache Cache to use for maintenance.
     */
    constructor(proxies, cache) {
        this.cb = new defaultCircuitBreakerMaintenance_1.DefaultCircuitBreakerMaintenance(proxies);
        this.c = new defaultCacheMaintenance_1.DefaultCacheMaintenance(cache);
    }
    /**
     * Gets circuit breaker maintenance.
     */
    circuitBreaker() {
        return this.cb;
    }
    /**
     * Gets cache maintanance.
     */
    cache() {
        return this.c;
    }
}
exports.DefaultMaintenance = DefaultMaintenance;
//# sourceMappingURL=defaultMaintenance.js.map